// для скроллинга к блокам
export const TOUR_LIST_ELEM_ID = 'tour-list';
export const HOTEL_MAP_ELEM_ID = 'hotel-on-map';
export const HOTEL_REVIEWS_LIST_ELEM_ID = 'hotel-review-list';
export const HOTEL_ROOM_FACILITIES_ID = 'hotel-room-facilities';
export const HOTEL_BASIC_INFO_ID = 'hotel-basic-info';
export const TAB_NAVIGATION_MAIN_ID = 'tab-navigation-main';
export const ROOMS_ID = 'rooms';
